import _ from 'underscore';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import * as PopupEditor from '@bingads-webui/popup-editor';
import { NegativeKeyword } from '@bingads-webui-campaign/campaign-ui-schemas';
import { InlineEditableSave } from './save';

let schema = NegativeKeyword;

// todo: move to common-columns package [1212933]
export function InlineEditableColumnPrompt({
  position, item, view, i18n, fieldName, customSchema,
}) {
  if (!customSchema) {
    schema = cloneDeep(schema);
    schema.properties.MatchType.enum = _.without(schema.properties.MatchType.enum, 'Content');
  } else {
    schema = customSchema;
  }
  let fields = [fieldName];
  const model = item;

  const prompt = (template = 'inline') =>
    PopupEditor.prompt({
      position,
      i18n,
      schema,
      model,
      fields,
      hasLabels: false,
      template,
      saveModel: (updated, editorView) =>
        InlineEditableSave({
          view,
          i18n,
          fieldName,
          updated,
          editorView,
          entityName: customSchema ? customSchema.name : undefined,
          editorViewCallbackAfterUpdate: () => {
            editorView.trigger('save', updated);
          },
        }),
    });

  if (fieldName === 'MatchType') {
    const valueMessages = {};
    _.each(schema.properties.MatchType.enum, (value) => {
      valueMessages[value] = i18n.getString(`MatchType_${value}`);
    });
    fields = [{
      property: fieldName,
      valueMessages,
    }];
  }
  prompt();
}
